import { render, staticRenderFns } from "./LimitedForm.vue?vue&type=template&id=20ef76de&"
import script from "./LimitedForm.vue?vue&type=script&lang=js&"
export * from "./LimitedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports